import { useCallback, useMemo, useState } from "react";
import { useParams, useLocation } from 'react-router-dom';

import queryString from 'query-string'

import createContextFactory from "@Utils/factory";

function useContestsSubscriptionsStateFactory() {
  const { sweepId } = useParams()
  const { search } = useLocation()

  const [selectedFields, setSelectedFields] = useState([
    "userId",
    "userFirstName",
    "userLastName",
    "userEmail",
    "userGender",
    "userSessionConverted",
    "userSessionRegistrationCompleted",
  ])

  const parseURL = useCallback(() => {
    const query = queryString.parse(search)
    const params = sweepId ? { sweepId } : {}
    if (query && query?.configure) {
      return { ...params, ...JSON.parse(atob(query.configure)) }
    } else {
      throw new Error()
    }
  }, [sweepId, search])

  const query = useMemo(() => {
    const filterBy = parseURL()
    return { filterBy, fields: selectedFields }
  }, [selectedFields, parseURL])

  return useMemo(() => ({
    query,
    options: OPTIONS,
    selectedFields, setSelectedFields,
  }), [query, selectedFields, setSelectedFields])
}

const {
  Provider: ContestsSubscriptionsStateProvider,
  useContext: useContestsSubscriptionsState,
} = createContextFactory(useContestsSubscriptionsStateFactory)

export {
  useContestsSubscriptionsState,
  ContestsSubscriptionsStateProvider,
}

const OPTIONS = [
  { group: "Subscription", value: "id", label: "Id" },
  { group: "Subscription", value: "ticket", label: "Ticket" },
  { group: "Subscription", value: "contestId", label: "contest Id" },
  { group: "Subscription", value: "sweepId", label: "sweep Id" },
  { group: "Subscription", value: "confirmed", label: "confirmed" },

  { group: "User", value: "userId", label: "id" },
  { group: "User", value: "userCreatedAt", label: "Created At" },
  { group: "User", value: "userUpdatedAt", label: "Updated At" },
  { group: "User", value: "userFirstName", label: "First Name" },
  { group: "User", value: "userLastName", label: "Last Name" },
  { group: "User", value: "userEmail", label: "Email" },
  { group: "User", value: "userCity", label: "City" },
  { group: "User", value: "userCountry", label: "Country" },
  { group: "User", value: "userGender", label: "Gender" },
  { group: "User", value: "userDob", label: "Dob" },
  { group: "User", value: "userPhone", label: "Phone" },
  { group: "User", value: "userEmailMd5", label: "email Md5" },
  { group: "User", value: "userAddress1", label: "Address 1" },
  { group: "User", value: "userAddress2", label: "Address 2" },
  { group: "User", value: "userState", label: "State" },
  { group: "User", value: "userZip", label: "Zip" },
  { group: "User", value: "userCustomFields", label: "Custom Fields" },
  { group: "User", value: "userUnsubscribed", label: "Unsubscribed" },
  { group: "User", value: "userSiteId", label: "Site Id" },
  { group: "User", value: "userIsOptout", label: "Is Optout" },
  { group: "User", value: "userMeta", label: "Meta" },
  { group: "User", value: "userRevenue", label: "Revenue" },

  { group: "User Session", value: "userSessionConversionType", label: "Conversion Type" },
  { group: "User Session", value: "userSessionConverted", label: "Converted" },
  { group: "User Session", value: "userSessionTcpaConsent", label: "TCPA Consent" },
  { group: "User Session", value: "userSessionRegistrationConsent", label: "Registration Consent" },
  { group: "User Session", value: "userSessionRegistrationCompleted", label: "Registration Completed" },
  { group: "User Session", value: "userSessionDuplicated", label: "Duplicated" },
  { group: "User Session", value: "userSessionSkipRegistration", label: "Skip Registration" },
  { group: "User Session", value: "userSessionEmailVerification", label: "Email Verification" },
  { group: "User Session", value: "userSessionBotVerification", label: "Bot Verification" },
  { group: "User Session", value: "userSessionFraudVerification", label: "Fraud Verification" },
  { group: "User Session", value: "userSessionPhoneVerification", label: "Phone Verification" },
  { group: "User Session", value: "userSessionDevice", label: "Device" },
  { group: "User Session", value: "userSessionId", label: "Id" },
  { group: "User Session", value: "userSessionUsessionid", label: "Cookie" },
  { group: "User Session", value: "userSessionCreatedAt", label: "Created At" },
  { group: "User Session", value: "userSessionUpdatedAt", label: "Updated At" },
  { group: "User Session", value: "userSessionAllocationId", label: "Allocation Id" },
  { group: "User Session", value: "userSessionFormId", label: "Form Id" },
  { group: "User Session", value: "userSessionOfferId", label: "Offer Id" },
  { group: "User Session", value: "userSessionPublisherId", label: "Publisher Id" },
  { group: "User Session", value: "userSessionPostId", label: "Post Id" },
  { group: "User Session", value: "userSessionPostTargetId", label: "Post Target Id" },
  { group: "User Session", value: "userSessionPostVersionId", label: "Post Version Id" },
  { group: "User Session", value: "userSessionSid1", label: "Sid 1" },
  { group: "User Session", value: "userSessionSid2", label: "Sid 2" },
  { group: "User Session", value: "userSessionSid3", label: "Sid 3" },
  { group: "User Session", value: "userSessionPayouttype", label: "Payout Type" },
  { group: "User Session", value: "userSessionCost", label: "Cost" },
  { group: "User Session", value: "userSessionSessionid", label: "Session UUID" },
  { group: "User Session", value: "userSessionBrowseragent", label: "Browser agent" },
  { group: "User Session", value: "userSessionExternalid", label: "External id" },
  { group: "User Session", value: "userSessionCampaignid", label: "Campaign id" },
  { group: "User Session", value: "userSessionReferrer", label: "Referrer" },
  { group: "User Session", value: "userSessionOriginalUrl", label: "Origina lUrl" },
  { group: "User Session", value: "userSessionIpaddress", label: "Ip address" },
  { group: "User Session", value: "userSessionOs", label: "OS" },
  { group: "User Session", value: "userSessionBrowser", label: "Browser" },
  { group: "User Session", value: "userSessionTrustedformCert", label: "Trustedform Cert" },
  { group: "User Session", value: "userSessionLeadidCert", label: "Leadid Cert" },
  { group: "User Session", value: "userSessionRegistrationTotalStep", label: "Registration Total Step" },
  { group: "User Session", value: "userSessionRegistrationStep", label: "Registration Step" },
  { group: "User Session", value: "userSessionAddressVerification", label: "Address Verification" },
  { group: "User Session", value: "userSessionFraudscore", label: "Fraud score" },
  { group: "User Session", value: "userSessionMeta", label: "Meta" },
  { group: "User Session", value: "userSessionHook", label: "Hook" },
  { group: "User Session", value: "userSessionIsOptout", label: "Is Optout" },
  { group: "User Session", value: "userSessionPostalVerification", label: "Postal Verification" },
  { group: "User Session", value: "userSessionIpCity", label: "Ip City" },
  { group: "User Session", value: "userSessionIpState", label: "Ip State" },
  { group: "User Session", value: "userSessionIpZip", label: "Ip Zip" },
  { group: "User Session", value: "userSessionRevenue", label: "Revenue" },
]
